import { useEffect, useState } from 'react'
import ToggleButton from '../../../../../../components/ui/toggle_button/ToggleButton'
import Questionnaire from '../../../../../../libs/api/services/Questionnaire'

export default function QBuilderKeepOpen({ questionnaireId }) {
    const [keepOpen, setKeepOpen] = useState(false)

    const _handleSetOption = (option) => {
        Questionnaire
            .SetOption(questionnaireId, {
                name: 'KEEP_OPEN',
                value: JSON.stringify(option)
            })
            .then((r) => {
                //setTitleMode(r)
                setKeepOpen(option)
            }).catch(() => { })
    }
    const _handleGetOption = () => {
        Questionnaire
            .GetOption(questionnaireId, 'KEEP_OPEN')
            .then((r) => {
                try {
                    setKeepOpen(JSON.parse(r.value))
                } catch (e) { }
            }).catch((e) => { })
    }

    useEffect(() => {
        _handleGetOption()
    }, [])

    return (
        <ToggleButton onToggle={val => _handleSetOption(val)} defaultValue={keepOpen}>
            <div className='d-flex flex-column text-start'>
                <b>Keep questionnaire open</b>
                <p>This will keep the questionnaire available for updating at a later stage</p>
            </div>
        </ToggleButton>
    )
}
